import React, { Component } from "react";
import {
    Row,
    Col,
    FormGroup,
    ControlLabel,
    FormControl,
    Alert
  } from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import { fetchDepartmentRequest, createDepartmentRequest, editDepartmentRequest } from "../../../api/department";

class DepartmentForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      resource: {
        departmentName: ''
      },
      error: null
    }
  }

  componentDidMount() {
    const { instanceId } = this.props;

    if (instanceId) {
      this.fetchInstance(instanceId);
    } 
  }

  fetchInstance = (id) => {
      fetchDepartmentRequest(id,
          result => this.setState(prevState => ({
              resource: {
                  ...prevState.resource,
                  ...result
              }
          })), error => this.setState({ error: 'There was an error' }));
  }

  handleFormChange = (e) => {
    const { target } = e;
    const { name, value } = target;

    this.setState(prevState => ({
      resource: {
        ...prevState.resource,
        [name]: value,
      },
    }))
  }

  save = () => {
    const {
      departmentName
    } = this.state.resource;

    const {
      instanceId
    } = this.props;

    const isNewRecord = !instanceId;

    let data = {
      departmentName
    };

    if (isNewRecord) {
        createDepartmentRequest(data,
            result => this.saveSuccess(),
            error => this.saveFailure(error)
        );
    } else {
        editDepartmentRequest(instanceId, data,
            result => this.saveSuccess(),
            error => this.saveFailure(error)
        );
    }
  }

  saveSuccess = () => {
    this.setState({ error: null });
    this.props.goToList('department');
  }

  saveFailure = (error) => {
      this.setState({ error: error.message || 'There was an error saving Department.' })
  }

  render() {

    const {
      departmentName
    } = this.state.resource;

    const {
      error
    } = this.state;

    const {
      instanceId
    } = this.props;

    const isNewRecord = !instanceId;

    return (
      <Row>
        <Col md={12}>
          <Card
            title={isNewRecord ? "New entry" : "Edit entry"}
            content={
              <form>
                <Button className="card-top-btn btn-primary" onClick={() => this.props.goToList('department')}>
                  Back to List
                </Button>
                <FormGroup>
                  <ControlLabel>Department Name</ControlLabel>
                  <FormControl
                    type="text"
                    name="departmentName"
                    value={departmentName}
                    onChange={this.handleFormChange}
                    placeholder=""
                  />
                </FormGroup>
                {error &&
                  <Alert bsStyle="danger">
                    {error}
                  </Alert>
                }
                <Button bsStyle="primary" pullRight fill onClick={this.save}>
                  {isNewRecord ? "Create" : "Save changes"}
                </Button>
                <div className="clearfix" />
              </form>
            }
          />
        </Col>
      </Row>
    )
  }
}

export default DepartmentForm;
